import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  I18n,
  Button,
  Heading,
  ErrorBlock,
} from 'components';

import { formatLogin } from 'utils/formatString';

import AccountPreview from '../AccountPreview';
import ContractPreview from '../ContractPreview';
import AccountEditPopup from '../AccountEditPopup';
import ContractEditPopup from '../ContractEditPopup';
import AccountGroupEditPopup from '../AccountGroupEditPopup';
import UnlinkAccountConfirmationPopup from '../UnlinkAccountConfirmationPopup';
import IncomingLinkageRequest from '../IncomingLinkageRequest';
import OutgoingLinkageRequest from '../OutgoingLinkageRequest';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class AssociatedAccounts extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deletingAccount: {},
      editingAccount: {},
    };
  }

  openConfirmationPopup = (deletingAccount) => {
    this.setState({ deletingAccount });
    this.props.toggleConfirmationDeletingPopup(true);
  };

  openAccountEditPopup = (editingAccount) => {
    this.setState({ editingAccount });
    this.props.toggleAccountEditPopup(true);
  };

  openContractEditPopup = (editingAccount) => {
    this.setState({ editingAccount });
    this.props.toggleContractEditPopup(true);
  };

  openAccountGroupEditPopup = (editingAccount) => {
    this.setState({ editingAccount });
    this.props.toggleAccountGroupEditPopup(true);
  };

  hasData() {
    const {
      ctns,
      fttbs,
      bans,
      bens,
      incomingLinkageRequests,
      outgoingLinkageRequests,
    } = this.props;

    return ctns
           && fttbs
           && bans
           && bens;
  }

  isEmpty() {
    const {
      ctns,
      fttbs,
      bans,
      bens,
      incomingLinkageRequests,
      outgoingLinkageRequests,
    } = this.props;

    return !ctns.length
           && !fttbs.length
           && !bans.length
           && !bens.length
           && !incomingLinkageRequests?.length
           && !outgoingLinkageRequests?.length;
  }

  render() {
    const {
      ctns,
      fttbs,
      bans,
      bens,
      linkAccount,
      isAccountLinkDeleting,
      cancelRequest,
      incomingLinkageRequests,
      outgoingLinkageRequests,
      updateLinkageRequest,
      isAssociatedAccountUpdating,
      updateAssociatedCtnAccount,
      updateAssociatedBanAccount,
      updateAssociatedBenAccount,
      error,
      refreshAction,
      toggleAccountEditPopup,
      toggleAccountGroupEditPopup,
      toggleContractEditPopup,
      isAccountEditPopupOpened,
      isAccountGroupEditPopupOpened,
      isContractEditPopupOpened,
      deleteAccountLink,
      toggleConfirmationDeletingPopup,
      isConfirmationDeletingPopupOpened,
    } = this.props;

    const {
      deletingAccount,
      editingAccount,
    } = this.state;

    if (error) {
      return (
        <ErrorBlock
          title={<I18n path="settings.numberManagement.associatedAccounts.title" />}
          refreshAction={refreshAction}
        />
      );
    }

    return (
      <DataBlocks.Block
        isLoading={!this.hasData()}
        title={<I18n path="settings.numberManagement.associatedAccounts.title" />}
        info={<I18n path="settings.numberManagement.associatedAccounts.info" />}
      >
        {this.hasData() && !this.isEmpty()
          ? (
            <DataBlocks.Table>
              {ctns.map((account) => (
                <AccountPreview
                  isMobile
                  key={`ctn-account-${account.login}`}
                  {...account}
                  openAccountEditPopup={this.openAccountEditPopup}
                  unlinkAccount={this.openConfirmationPopup}
                />
              ))}
              {fttbs.map((account) => (
                <AccountPreview
                  key={`fttb-account-${account.login}`}
                  {...account}
                  openAccountEditPopup={this.openAccountEditPopup}
                  unlinkAccount={this.openConfirmationPopup}
                />
              ))}
              {bans.map((account) => (
                <ContractPreview
                  key={`ban-account-${account.ban}`}
                  {...account}
                  openAccountEditPopup={this.openAccountEditPopup}
                  openContractEditPopup={this.openContractEditPopup}
                  openAccountGroupEditPopup={this.openAccountGroupEditPopup}
                  unlinkAccount={this.openConfirmationPopup}
                />
              ))}
              {bens.map((account) => (
                <ContractPreview
                  key={`ben-account-${account.ban}`}
                  {...account}
                  openAccountEditPopup={this.openAccountEditPopup}
                  openContractEditPopup={this.openContractEditPopup}
                  unlinkAccount={this.openConfirmationPopup}
                />
              ))}
              {/*{incomingLinkageRequests.map((linkageRequest) => (*/}
              {/*  <IncomingLinkageRequest*/}
              {/*    key={`incoming-linkage-request-${linkageRequest.initiatorName}`}*/}
              {/*    messageText={<I18n path="settings.numberManagement.associatedAccounts.incomingLinkageRequestHint" />}*/}
              {/*    acceptText={<I18n path="settings.numberManagement.acceptRequest" />}*/}
              {/*    declineText={<I18n path="settings.numberManagement.decline" />}*/}
              {/*    {...linkageRequest}*/}
              {/*    updateLinkageRequest={updateLinkageRequest}*/}
              {/*  />*/}
              {/*))}*/}
              {/*{outgoingLinkageRequests.map((linkageRequest) => (*/}
              {/*  <OutgoingLinkageRequest*/}
              {/*    key={`outgoing-linkage-request-${linkageRequest.destinationName}`}*/}
              {/*    messageText={<I18n path="settings.numberManagement.associatedAccounts.outgoingLinkageRequestHint" />}*/}
              {/*    cancelRequestText={<I18n path="settings.numberManagement.cancelRequest" />}*/}
              {/*    {...linkageRequest}*/}
              {/*    cancelRequest={cancelRequest}*/}
              {/*  />*/}
              {/*))}*/}
            </DataBlocks.Table>
          )
          : (
            <div className={cx('emptyMessage')}>
              <I18n path="settings.numberManagement.associatedAccounts.emptyMessage" />
            </div>
          )}
        <div className={cx('button')}>
          <Button
            className="default"
            onClick={linkAccount}
          >
            <I18n path="settings.numberManagement.associatedAccounts.addPhoneNumber" />
          </Button>
        </div>
        <UnlinkAccountConfirmationPopup
          isConfirmationPopupOpened={isConfirmationDeletingPopupOpened}
          isAccountLinkDeleting={isAccountLinkDeleting}
          onClose={() => toggleConfirmationDeletingPopup(false)}
          onDelete={() => deleteAccountLink(deletingAccount.login)}
          deleteButtonText={<I18n path="settings.numberManagement.unlinkChildAccountButtonText" />}
          cancelButtonText={<I18n path="settings.numberManagement.cancelChanges" />}
        >
          <Heading level={3}>
            <I18n
              path="settings.numberManagement.associatingAccount.unlinkConfirmationMessage"
              vars={{
                login: formatLogin(
                  deletingAccount.login,
                  !deletingAccount.isMobile,
                ),
              }}
            />
          </Heading>
          <Heading level={6}>
            <I18n path="settings.numberManagement.associatingAccount.unlinkConfirmationDescription" />
          </Heading>
        </UnlinkAccountConfirmationPopup>
        <AccountEditPopup
          {...editingAccount}
          isOpened={isAccountEditPopupOpened}
          isAssociatedAccountUpdating={isAssociatedAccountUpdating}
          onClose={() => toggleAccountEditPopup(false)}
          onSave={updateAssociatedCtnAccount}
        />
        <ContractEditPopup
          {...editingAccount}
          isOpened={isContractEditPopupOpened}
          isAssociatedAccountUpdating={isAssociatedAccountUpdating}
          onClose={() => toggleContractEditPopup(false)}
          onSave={updateAssociatedBanAccount}
        />
        <AccountGroupEditPopup
          {...editingAccount}
          isOpened={isAccountGroupEditPopupOpened}
          isAssociatedAccountUpdating={isAssociatedAccountUpdating}
          onClose={() => toggleAccountGroupEditPopup(false)}
          onSave={updateAssociatedBenAccount}
        />
      </DataBlocks.Block>
    );
  }
}

AssociatedAccounts.propTypes = {
  error: PropTypes.string,
  ctns: PropTypes.array,
  fttbs: PropTypes.array,
  bans: PropTypes.array,
  bens: PropTypes.array,
  linkAccount: PropTypes.func,
  deleteAccountLink: PropTypes.func,
  isAccountLinkDeleting: PropTypes.bool,
  isAssociatedAccountUpdating: PropTypes.bool,
  isAccountEditPopupOpened: PropTypes.bool,
  isAccountGroupEditPopupOpened: PropTypes.bool,
  isContractEditPopupOpened: PropTypes.bool,
  isConfirmationDeletingPopupOpened: PropTypes.bool,
  incomingLinkageRequests: PropTypes.array,
  outgoingLinkageRequests: PropTypes.array,
  cancelRequest: PropTypes.func,
  updateLinkageRequest: PropTypes.func,
  updateAssociatedCtnAccount: PropTypes.func,
  updateAssociatedBanAccount: PropTypes.func,
  updateAssociatedBenAccount: PropTypes.func,
  refreshAction: PropTypes.func,
  toggleAccountEditPopup: PropTypes.func,
  toggleAccountGroupEditPopup: PropTypes.func,
  toggleContractEditPopup: PropTypes.func,
  toggleConfirmationDeletingPopup: PropTypes.func,
};

export default AssociatedAccounts;
